import React, { Component } from 'react';
import AnimateOnChange from 'react-animate-on-change';
import onClickOutside from 'react-onclickoutside';
import style from './PlayerOptionsControl.css';
const kTrailLengthOptions = [1000000, 220];
const kTrailSvg = length => {
    let path = 'M5,3 Q25,4 10,10';
    if (length === kTrailLengthOptions[0])
        path += ' T25 20';
    return (React.createElement("svg", { width: "30", height: "30" },
        React.createElement("path", { d: path, fill: "none", stroke: "rgb(190, 190, 190)", strokeWidth: "4px" })));
};
class PlayerOptionsControl extends Component {
    componentWillMount() {
        this.setState({ toggleList: true, hovered: false });
    }
    handleClickOutside() {
        // only close if opened as to all clicks this is always listening
        if (this.state.toggleList)
            return;
        this.closeMenu();
    }
    closeMenu() {
        this.setState({ toggleList: !this.state.toggleList });
        clearTimeout(this.showTimeout);
        delete this.showTimeout;
    }
    showOptions() {
        if (this.showTimeout) {
            this.setState({ toggleList: !this.state.toggleList });
            clearTimeout(this.showTimeout);
            delete this.showTimeout;
            return;
        }
        this.showTimeout = setTimeout(() => {
            if (this.state.hovered)
                return;
            this.closeMenu();
        }, 3000);
    }
    render() {
        return (React.createElement("div", { className: style.optionsList, onMouseEnter: () => {
                this.setState({ hovered: true });
            }, onMouseLeave: () => {
                this.setState({ hovered: false });
            } },
            React.createElement(AnimateOnChange, { baseClassName: `${style.options} menuOptions`, animationClassName: "hideMenuOptions", animate: this.state.toggleList },
                React.createElement("div", { className: `${style.option} ${style.trailLength}`, onClick: () => {
                        this.props.setTrailLength(this.props.trailLength === kTrailLengthOptions[0]
                            ? kTrailLengthOptions[1]
                            : kTrailLengthOptions[0]);
                    } }, kTrailSvg(this.props.trailLength)),
                React.createElement("div", { className: `${style.option} ${style.units}`, onClick: () => {
                        const unit = this.props.units === 'km' ? 'imperial' : 'metric';
                        this.props.updateUnits(unit);
                    } }, this.props.units)),
            React.createElement("div", { className: `${this.props.isMobile ? style.mobile : ''} ${style.button}`, name: "sliders", onClick: () => {
                    if (this.state.toggleList) {
                        this.setState({ toggleList: !this.state.toggleList });
                    }
                    this.showOptions();
                } },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 22 20" },
                    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(-9 -10)" },
                        React.createElement("rect", { width: "40", height: "40" }),
                        React.createElement("path", { stroke: "white", strokeLinecap: "round", strokeWidth: "2", d: "M20,11.5 L20,12.8254291 M20,18.3774601 L20,28.5" }),
                        React.createElement("circle", { cx: "20", cy: "15.5", r: "2.5", stroke: "white", strokeWidth: "2" }),
                        React.createElement("path", { stroke: "white", strokeLinecap: "round", strokeWidth: "2", d: "M13,11.5 L13,21.9630119 M13,27.0683511 L13,28.5" }),
                        React.createElement("circle", { cx: "13", cy: "24.5", r: "2.5", stroke: "white", strokeWidth: "2" }),
                        React.createElement("path", { stroke: "white", strokeLinecap: "round", strokeWidth: "2", d: "M27,11.5 L27,18.9000001 M27,24.4577188 L27,28.5" }),
                        React.createElement("circle", { cx: "27", cy: "21.5", r: "2.5", stroke: "white", strokeWidth: "2" }))))));
    }
}
export default onClickOutside(PlayerOptionsControl);
